<template lang="pug">
.cabecalho
  .cabecalho__visualizacao-mobile.columns.is-mobile.is-vcentered(v-if="ehVisualizacaoMobile")
    .column
      img.cabecalho__imagem-logo.to-click(@click="irParaTelaDeInicio", tabindex='0', :src="srcLogoPontotel", alt="$t('componentes.header.altLogoPontoTel')")
    .column(v-if="visual.clientLogo")
      img.cabecalho__logo-do-cliente(@click="irParaTelaDeInicio", :src="visual.clientLogo")

    span.cabecalho__toogle(@click="toggle = !toggle")
      font-awesome-icon(icon="bars")

  .cabecalho__visualizacao-web.columns.is-vcentered(v-if="toggle || !ehVisualizacaoMobile")
    .column.has-text-centered(v-if="!ehVisualizacaoMobile", style="padding: 0;")
      img.cabecalho__imagem-logo.to-click(@click="irParaTelaDeInicio", tabindex='0', :src="srcLogoPontotel", alt="$t('componentes.header.altLogoPontoTel')")

    template(v-if="informacoesRelacionadasAMarcacao")
      .column.has-text-centered(v-if="empregadoSincronizado")
        div(tabindex="0")
          span.cabecalho__nome-do-empregado {{ $t('componentes.header.logadoInfos.saudacao') }}, {{ empregadoSincronizado.nome }}
      div
        div(tabindex="0")
          span {{ $t('componentes.header.logadoInfos.labelEmpregador') }}:
          span.cabecalho__texto-em-negrito  {{ empregadoSincronizado.empregador.razao_social }}
        div(tabindex="0")
          span {{ $t('componentes.header.logadoInfos.labelLocalDeTrabalhoPessoal') }}:
          span.cabecalho__texto-em-negrito  {{  localDeTrabalhoMarcacao.nome }}

    template(v-if="locaisDeTrabalho.length && !rotasAposSincronizacao")
      .column.has-text-centered(v-if="empregadoSincronizado")
        span.cabecalho__nome-do-empregado(tabindex="0") {{ $t('componentes.header.logadoInfos.saudacao') }}, {{ empregadoSincronizado.nome }}
        .row(v-if="empregadoSincronizado && visual.webEmployerName")
          small.cabecalho__razao-social {{(empregadoSincronizado.empregador.razao_social)}}

      .cabecalho__informacoes-do-empregado.column.has-text-centered(v-if="visual.webShowCompanyTextHeader && locaisDeTrabalho[0]")
        div(v-if="tipoColetor === 'Pessoal' && localPadraoEmpregadoSincronizado")
          span(tabindex="0") {{ $t('componentes.header.logadoInfos.labelLocalDeTrabalhoPessoal') }}: {{localPadraoEmpregadoSincronizado.nome}}

        .cabecalho__local-de-trabalho(v-if="tipoColetor === 'Coletivo'", tabindex='0')
          span(
            v-if="locaisDeTrabalho.length"
            tabindex="0"
          ) {{ $t('componentes.header.logadoInfos.labelLocalDeTrabalhoColetivo') }}: {{ locaisDeTrabalho[0].nome }}

          button.cabecalho__local-de-trabalho--botao(
            v-if="locaisDeTrabalho.length > 1"
            :title="$t('componentes.header.logadoInfos.botoaMultiplosLocais')"
            @click="redirecionarParaTelaDeLocaisDeTrabalho"
          )
            .icone-chapado-local-ativo

    .column.has-text-centered(v-if="!ehVisualizacaoMobile && visual.clientLogo" )
      img.cabecalho__logo-do-cliente.re-mobile(:src="visual.clientLogo")

    .column.has-text-centered(v-if="!ehVisualizacaoMobile && !visual.clientLogo" )
      .row(v-if="visual.webButtonAccessSystem")
        a.cabecalho__app-gestao(@click="irParaAplicacao", tabindex='0', aria-label="acessar o sistema PontoTel") {{$t('componentes.header.logadoInfos.linkAcesseOSistema')}}

    .column.has-text-centered
      .row(v-if="visual.webButtonLogout && (visual.clientLogo || ehVisualizacaoMobile)")
        span  &nbsp;
      .row(v-if="visual.webButtonLogout && (visual.clientLogo || ehVisualizacaoMobile)")
        a.cabecalho__app-gestao(@click="irParaAplicacao", tabindex='0', aria-label="acessar o sistema PontoTel") {{$t('componentes.header.logadoInfos.linkAcesseOSistema')}}
      selecionar-idioma.cabecalho__seletor.column
</template>

<script>
import { gerarUrlGetS3File } from '../../api'
import { mapGetters } from 'vuex'
import router from '../../router/router'
import config from '../../config'
import Toasted from 'vue-toasted'
import Vue from 'vue'
import SelecionarIdioma from '../Idiomas/Idiomas'

Vue.use(Toasted)

export default {
  components: { SelecionarIdioma },
  data: () => ({
    larguraDaTela: 0,
    toggle: true,
    srcLogoPontotel: require('/static/images/pontotel-novo-branco.png')
  }),
  created () {
    this.verificarVersao()
    window.addEventListener('resize', this.manipularRedimensionamento)
    this.manipularRedimensionamento()
  },
  destroyed () {
    window.removeEventListener('resize', this.manipularRedimensionamento)
  },
  computed: {
    ...mapGetters(['visual']),
    ehVisualizacaoMobile () {
      return Boolean(this.larguraDaTela <= 768)
    },
    ehEmpresaBV () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '5cd49411d28021000c09e013'
      } else {
        return false
      }
    },
    ehEmpresaNubank () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '56d7358536a3b600dc7e2b3e'
      } else {
        return false
      }
    },
    ehEmpresaSiscom () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '5fda868ca5473094b8f9fdfc'
      } else {
        return false
      }
    },
    ehEmpresaXP () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '6040ca9dcc154d8db46cb4f9'
      } else {
        return false
      }
    },
    ehEmpresaAfya () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '6040cbd7fbe95b5533205844'
      } else {
        return false
      }
    },
    ehEmpresaDCMatrix () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '60ba78851f45f75bda269b42'
      } else {
        return false
      }
    },
    ehEmpresaGS () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '62f17ad2c37ebd5fcb694f7c'
      } else {
        return false
      }
    },
    ehEmpresaVibra () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '63568fce9b679d810190386a'
      } else {
        return false
      }
    },
    ehCreditSuisse () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '617c6cb5916e9754c0af133a'
      } else {
        return false
      }
    },
    ehEmpresaCyrella () {
      if (this.$store.state.accessData && this.$store.state.accessData.coletor) {
        return this.$store.state.accessData.coletor.clientId === '63693dafcd05bee20b8c9077'
      } else {
        return false
      }
    },
    ehAmbienteDev () {
      return location.href.includes('localhost')
    },
    ehAmbienteHomologacao () {
      return location.href.includes('hml.pontotel.com.br/pontotel/bateponto')
    },
    ehAmbienteProducao () {
      return location.href.includes('bateponto.pontotel.com.br')
    },
    rotasAposSincronizacao () {
      if (
        this.rotaAtual === 'marcacao' ||
        this.rotaAtual === 'historicoMarcacao' ||
        this.rotaAtual === 'confirmacaoDados' ||
        this.rotaAtual === 'confirmacaoPonto' ||
        this.rotaAtual === 'listaLocaisDeTrabalho'
      ) return true
      return false
    },
    informacoesRelacionadasAMarcacao () {
      if (
        this.rotasAposSincronizacao &&
        this.localDeTrabalhoMarcacao &&
        this.empregadoSincronizado
      ) {
        return true
      }
      return false
    },
    empregadoSincronizado () {
      return this.$store.getters['sincronizador/empregadoSincronizado']
    },
    locaisDeTrabalho () {
      return this.$store.getters['sincronizador/locaisColetor']
    },
    rotaAtual () {
      return this.$route.name
    },
    localDeTrabalhoMarcacao () {
      return this.$store.state.marcacao.localDeTrabalhoMarcacao
    },
    tipoColetor () {
      return this.$store.state.accessData.coletor.tipoColetor
    },
    localPadraoEmpregadoSincronizado () {
      return this.$store.state.accessData.coletor.localPadraoEmpregadoSincronizado
    }
  },
  methods: {
    redirecionarParaTelaDeLocaisDeTrabalho () {
      this.$router.push({ name: 'listaLocaisDeTrabalho' })
    },
    manipularRedimensionamento () {
      this.larguraDaTela = window.innerWidth
      if (this.larguraDaTela <= 768) {
        this.toggle = false
      }
    },
    verificarVersao () {
      try {
        this.$http.get(gerarUrlGetS3File())
          .then((resultadoDaApi) => {
            const novaVersaoWeb = Number(resultadoDaApi.data)
            const versaoDoApp = Number(config.version.split('.').join(''))

            if (novaVersaoWeb > versaoDoApp) {
              Vue.toasted.show(this.$t('componentes.header.checarVersaoPontoTel.novaVersaoDisponivel', {
                position: 'top-right',
                iconPack: 'material',
                singleton: true,
                action: {
                  text: this.$t('componentes.header.checarVersaoPontoTel.atualizar'),
                  onClick: (e, toastObject) => {
                    location.reload(true)
                    toastObject.goAway(0)
                  }
                }
              }))
            }
          })
          .catch((erro) => {
            const mensagemDeErro = erro?.body?.detail || this.$t('componentes.header.checarVersaoPontoTel.versaoNaoEncontrada')
            this.$modalDeErro(mensagemDeErro)
          })
      } catch (erro) {
        const mensagemDeErro = erro?.body?.detail || this.$t('componentes.header.checarVersaoPontoTel.versaoNaoEncontrada')
        this.$modalDeErro(mensagemDeErro)
      }
    },
    irParaTelaDeInicio () {
      if (this.ehAmbienteDev) {
        router.push({name: 'sincronizador'})
      } else if (this.ehAmbienteHomologacao) {
        if (this.ehEmpresaBV) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim')
        } else if (this.ehEmpresaNubank) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/nubank-pontotel')
        } else if (this.ehEmpresaSiscom) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/Siscom')
        } else if (this.ehEmpresaXP) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp')
        } else if (this.ehEmpresaAfya) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel')
        } else if (this.ehEmpresaDCMatrix) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/dcmatrix-pontotel')
        } else if (this.ehEmpresaGS) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/gs-pontotel')
        } else if (this.ehEmpresaVibra) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/vibra-pontotel')
        } else if (this.ehCreditSuisse) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/creditsuisse-pontotel')
        } else if (this.ehEmpresaCyrella) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/cyrela-pontotel')
        } else {
          router.push({name: 'sincronizador'})
        }
      } else if (this.ehAmbienteProducao) {
        if (this.ehEmpresaBV) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim')
        } else if (this.ehEmpresaNubank) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/nubank-pontotel')
        } else if (this.ehEmpresaSiscom) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/Siscom')
        } else if (this.ehEmpresaXP) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/xp')
        } else if (this.ehEmpresaAfya) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel')
        } else if (this.ehEmpresaDCMatrix) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/dcmatrix-pontotel')
        } else if (this.ehEmpresaGS) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/gs-pontotel')
        } else if (this.ehEmpresaVibra) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/vibra-pontotel')
        } else if (this.ehCreditSuisse) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/creditsuisse-pontotel')
        } else if (this.ehEmpresaCyrella) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/front/cyrela-pontotel')
        } else {
          router.push({name: 'sincronizador'})
        }
      }
    },
    irParaAplicacao () {
      if (this.ehAmbienteDev) {
        window.open('http://localhost:8081', '_blank')
      } else if (this.ehAmbienteHomologacao) {
        if (this.ehEmpresaBV) {
          window.open('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim', '_blank')
        } else if (this.ehEmpresaNubank) {
          window.open('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/nubank-pontotel', '_blank')
        } else {
          window.open('https://homolog.pontotel.com.br', '_blank')
        }
      } else if (this.ehAmbienteProducao) {
        if (this.ehEmpresaBV) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim', '_blank')
        } else if (this.ehEmpresaNubank) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/nubank-pontotel', '_blank')
        } else if (this.ehEmpresaSiscom) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/Siscom', '_blank')
        } else if (this.ehEmpresaXP) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/xp', '_blank')
        } else if (this.ehEmpresaAfya) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel', '_blank')
        } else if (this.ehEmpresaDCMatrix) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/dcmatrix-pontotel', '_blank')
        } else if (this.ehEmpresaGS) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/gs-pontotel', '_blank')
        } else if (this.ehEmpresaVibra) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/vibra-pontotel', '_blank')
        } else if (this.ehCreditSuisse) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/creditsuisse-pontotel', '_blank')
        } else if (this.ehEmpresaCyrella) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/front/cyrela-pontotel', '_blank')
        } else {
          window.open('https://gestao.pontotel.com.br/#/', '_blank')
        }
      }
    }
  }
}
</script>

<style scoped>
.cabecalho__imagem-logo {
  width: 130px;
  height: 50px;
  margin-top: 8px;
}

.cabecalho {
  background-color: var(--web-color-header);
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 68px;
  align-items: center;
  justify-content: flex-end;
  padding: 1px;
}

.cabecalho > * {
  color: var(--web-color-font-header);
}

.cabecalho__nome-do-empregado {
  font-size: 18px;
  font-weight: bold;
  font-stretch: condensed;
}

.cabecalho__razao-social {
  font-size: 16px;
  font-weight: lighter;
  font-stretch: condensed;
}

.cabecalho__app-gestao {
  font-size: 16px;
  font-weight: lighter;
  font-stretch: condensed;
  background-color: transparent;
  color: #FFF;
  border: 2px solid transparent;
  transition-duration: 0.1s;
  padding: 0px;
}

.cabecalho__app-gestao:hover {
  color: var(--color-warning);
  border-bottom: 2px solid var(--color-warning);
}

.cabecalho__visualizacao-mobile {
  display: flex;
  flex-direction: column;
}

.cabecalho__toogle {
  font-size: 40px;
  padding-right: 15px;
}

.cabecalho__texto-em-negrito {
  font-weight: bold;
  font-stretch: condensed;
}

.cabecalho__informacoes-do-empregado {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cabecalho__local-de-trabalho {
  display: flex;
  align-items: baseline;
}

.cabecalho__local-de-trabalho--botao {
  height: 25px;
  width: 25px;
  margin-left: 0.25rem;
  padding: 0;
  border-radius: 0;
  background: transparent;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  cursor: pointer;
}

.icone-chapado-local-ativo {
  color: #fff;
  font-size: 1.2rem;
}

.cabecalho__visualizacao-web {
  align-items: center;
  width: 100%;
}

@media only screen and (min-width: 320px)  {
  .cabecalho {
    justify-content: center;
  }

  .cabecalho__seletor {
    display: flex;
    justify-content: flex-start;
  }

  img.re-mobile {
    max-width: 111px;
    max-height: 60px;
  }

  img.re-mobile.cabecalho__logo-do-cliente {
    max-width: 111px;
    max-height: 60px;
    min-height: 25px;
  }
}
</style>
